var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 940 229",
    width: 940,
    height: 229,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Passport Logo EPS-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #68c7c6 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "by CMX"
  }, /*#__PURE__*/React.createElement("g", {
    id: "by"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m606.4 188.7h-19.4v-40.6h18.9c8.3 0 13.4 4.1 13.4 10.5v0.1c0 4.6-2.4 7.1-5.3 8.8 4.7 1.8 7.6 4.5 7.6 10v0.1c0 7.4-6 11.1-15.2 11.1zm4.1-28.6c0-2.7-2.1-4.2-5.9-4.2h-8.8v8.6h8.2c4 0 6.5-1.3 6.5-4.3zm2.2 16.3c0-2.8-2-4.5-6.6-4.5h-10.3v9h10.6c3.9 0 6.3-1.4 6.3-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m648.4 172.5v16.2h-8.9v-16l-15.6-24.6h10.4l9.7 16.3 9.9-16.3h10.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CMX"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m904.9 169.5l-14.5-20.6h28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m743.6 206.3l3.9 2.8c-7.4 11.7-20.4 19.4-35.2 19.4-22.9 0-41.5-18.6-41.5-41.6 0-23 18.6-41.6 41.5-41.6 14.4 0 27.1 7.3 34.5 18.4l-3.8 2.9c-6.6-9.9-17.9-16.5-30.7-16.5-20.3 0-36.7 16.5-36.7 36.8 0 20.3 16.4 36.8 36.7 36.8 13.2 0 24.7-7 31.3-17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m728.7 195.7l13.9 9.9c-6.3 10.1-17.5 16.9-30.3 16.9-19.6 0-35.6-16-35.6-35.6 0-19.6 16-35.6 35.6-35.6 12.4 0 23.4 6.4 29.8 16l-13.6 10.5c-3.2-5.6-9.2-9.4-16.2-9.4-10.2 0-18.5 8.3-18.5 18.5 0 10.2 8.3 18.5 18.5 18.5 7.1 0 13.2-3.9 16.4-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m835.8 225.1h-24.3l24.3-38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m759.2 148.9v76.2h-4.8v-76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m835.8 148.9l-0.3 0.5-40.2 61.8h-0.3l-19.5-29.9v43.8h-15.1v-76.2h16.4l18.2 29.5 18.1-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m913.2 225.1l-52.4-76.2h5.5l53.3 76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m859.4 148.9l52.4 76.2h-19.3l-13-20.6-13.1 20.6h-26.8l26.1-38.7-25.1-37.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SM"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m927.9 223.4c0 0.8 0.7 1.2 1.4 1.2 0.9 0 1.2-0.4 1.2-0.9 0-0.4-0.2-0.5-0.5-0.6-0.4-0.2-0.9-0.3-1.6-0.5-0.9-0.2-1.2-0.8-1.2-1.4 0-1.1 1-1.6 2-1.6 1.1 0 2.1 0.6 2.1 1.8h-1c0-0.7-0.5-1-1.2-1-0.4 0-1 0.2-1 0.7 0 0.4 0.3 0.6 0.7 0.7 0.1 0 1.3 0.4 1.6 0.4 0.7 0.3 1 0.9 1 1.4 0 1.3-1 1.7-2.1 1.7-1.3 0-2.3-0.5-2.3-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m932.3 219.8h1.3l1.5 4.2 1.5-4.2h1.3v5.4h-0.9v-4.2l-1.5 4.2h-0.8l-1.5-4.2v4.2h-0.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p 00000004522713019209914410000008088377476931082138 ",
    fillRule: "evenodd",
    className: "s0",
    d: "m0.7 2.8h49.6c28.9 0 46.4 17.2 46.4 41.9v0.4c0 28-21.8 42.6-49 42.6h-20.3v36.4h-26.7zm47.8 61.1c13.4 0 21.2-8 21.2-18.4v-0.3c0-11.9-8.3-18.4-21.7-18.4h-20.6v37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s 00000173852779875948484400000015870428627742876290 ",
    className: "s0",
    d: "m231.1 106.4l15.7-18.9c11 9 22.4 14.7 36.2 14.7 11 0 17.5-4.3 17.5-11.4v-0.3c0-6.8-4.1-10.2-24.4-15.4-24.4-6.3-40.2-13-40.2-37.1v-0.4c0-22 17.7-36.5 42.5-36.5 17.6 0 32.7 5.5 45 15.4l-13.9 20.1c-10.7-7.4-21.3-11.9-31.5-11.9-10.2 0-15.6 4.6-15.6 10.5v0.4c0 7.9 5.2 10.5 26.2 15.9 24.6 6.4 38.4 15.2 38.4 36.4v0.3c0 24.1-18.3 37.6-44.5 37.6-18.3 0-36.9-6.4-51.4-19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s 00000080165393649276167440000012911933002539718020 ",
    className: "s0",
    d: "m340.2 106.4l15.8-18.9c10.9 9 22.3 14.7 36.2 14.7 10.9 0 17.4-4.3 17.4-11.4v-0.3c0-6.8-4.1-10.2-24.4-15.4-24.4-6.3-40.2-13-40.2-37.1v-0.4c0-22 17.7-36.5 42.5-36.5 17.6 0 32.7 5.5 45 15.4l-13.8 20.1c-10.8-7.4-21.3-11.9-31.6-11.9-10.2 0-15.6 4.6-15.6 10.5v0.4c0 7.9 5.2 10.5 26.2 15.9 24.6 6.4 38.4 15.2 38.4 36.4v0.3c0 24.1-18.3 37.6-44.5 37.6-18.3 0-36.9-6.4-51.4-19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p 00000044869376794401245180000013980960186707693184 ",
    fillRule: "evenodd",
    className: "s0",
    d: "m459.4 2.8h49.5c28.9 0 46.4 17.2 46.4 41.9v0.4c0 28-21.8 42.6-49 42.6h-20.3v36.4h-26.6zm47.8 61.1c13.3 0 21.1-8 21.1-18.4v-0.3c0-11.9-8.3-18.4-21.7-18.4h-20.6v37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o 00000137840086901310101940000012350091488263474325 ",
    fillRule: "evenodd",
    className: "s0",
    d: "m569.7 63.8v-0.3c0-34.5 27.2-62.7 64.6-62.7 37.4 0 64.2 27.8 64.2 62.3v0.4c0 34.4-27.2 62.6-64.6 62.6-37.4 0-64.2-27.8-64.2-62.3zm101 0v-0.3c0-20.8-15.3-38.2-36.8-38.2-21.4 0-36.3 17-36.3 37.8v0.4c0 20.7 15.2 38.1 36.7 38.1 21.5 0 36.4-17 36.4-37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r 00000005242558302511633150000002111363971815336328 ",
    fillRule: "evenodd",
    className: "s0",
    d: "m722.3 2.8h55.4c15.4 0 27.3 4.4 35.3 12.3 6.8 6.8 10.4 16.3 10.4 27.7v0.4c0 19.6-10.6 31.9-26 37.6l29.6 43.3h-31.1l-26-38.8h-21v38.8h-26.6zm53.7 58.9c12.9 0 20.4-7 20.4-17.2v-0.3c0-11.5-8-17.4-21-17.4h-26.5v34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t 00000164500043938958768800000015912936974392401542 ",
    className: "s0",
    d: "m875.7 27.4h-36.9v-24.6h100.5v24.6h-36.9v96.7h-26.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m152.9 2.8l69.5 121.3h-136.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmxLogo);
export default __webpack_public_path__ + "static/media/cmx-logo.8d72129d1cae4807aac379bee807aef6.svg";
export { ForwardRef as ReactComponent };